module.exports = __webpack_public_path__ + "img/zigbee-repeater-lg.5f4b83e7.svg";